const h1 = {
  fontSize: {
    base: 33,
    sm: 33,
    md: 39,
    lg: 39,
    xl: 39
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    lg: 'medium',
    md: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 39.6,
    sm: 39.6,
    lg: 46.8,
    md: 46.8,
    xl: 46.8
  },
  fontFamily: 'body'
};
const h2 = {
  fontSize: {
    base: 28,
    sm: 28,
    md: 31,
    lg: 31,
    xl: 31
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    lg: 'medium',
    md: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 33.6,
    sm: 33.6,
    lg: 37.2,
    md: 37.2,
    xl: 37.2
  },
  fontFamily: 'body'
};
const h3 = {
  fontSize: {
    base: 25,
    sm: 25,
    md: 23,
    lg: 23,
    xl: 23
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    lg: 'medium',
    md: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 27.6,
    sm: 27.6,
    lg: 30,
    md: 30,
    xl: 30
  },
  fontFamily: 'body'
};
const body20 = {
  fontSize: {
    base: 19,
    sm: 19,
    md: 20,
    lg: 20,
    xl: 20
  },
  fontWeight: {
    sm: 'normal',
    base: 'normal',
    lg: 'normal',
    md: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 22.8,
    sm: 22.8,
    lg: 24,
    md: 24,
    xl: 24
  },
  fontFamily: 'body'
};
const body16 = {
  fontSize: {
    base: 16,
    sm: 16,
    md: 16,
    lg: 16,
    xl: 16
  },
  fontWeight: {
    sm: 'normal',
    base: 'normal',
    lg: 'normal',
    md: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 24,
    sm: 24,
    lg: 24,
    md: 24,
    xl: 24
  },
  fontFamily: 'body'
};
const subtitle = {
  fontSize: {
    base: 13,
    sm: 13,
    md: 13,
    lg: 13,
    xl: 13
  },
  fontWeight: {
    sm: 'normal',
    base: 'normal',
    lg: 'normal',
    md: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const caption = {
  fontSize: {
    base: 11,
    sm: 11,
    md: 10,
    lg: 10,
    xl: 10
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    sm: 13.2,
    base: 13.2,
    lg: 12,
    md: 12,
    xl: 12
  },
  fontFamily: 'body'
};
const button = {
  fontSize: {
    base: 13,
    sm: 13,
    md: 14,
    lg: 15,
    xl: 15
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const inputLabel = {
  fontSize: {
    base: 16,
    sm: 16,
    md: 16,
    lg: 16,
    xl: 16
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    md: 19.2,
    lg: 19.2,
    xl: 19.2
  },
  fontFamily: 'body'
};
const inputText = {
  fontSize: {
    base: 16,
    sm: 16,
    md: 16,
    lg: 16,
    xl: 16
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    md: 22.8,
    lg: 22.8,
    xl: 22.8
  },
  fontFamily: 'body'
};
const trackerItem = {
  fontSize: {
    base: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    sm: 17.1,
    base: 17.1,
    lg: 17.1,
    md: 17.1,
    xl: 17.1
  },
  fontFamily: 'body'
};
const chips = {
  fontSize: {
    base: 10,
    sm: 10,
    md: 10,
    lg: 10,
    xl: 10
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    sm: 12,
    base: 12,
    lg: 12,
    md: 12,
    xl: 12
  },
  fontFamily: 'body'
};
const menuItem = {
  fontSize: {
    base: 14,
    sm: 14,
    md: 14,
    lg: 14,
    xl: 14
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    sm: 20,
    base: 20,
    lg: 20,
    md: 20,
    xl: 20
  },
  fontFamily: 'body'
};
const h4 = {
  fontSize: {
    base: 34,
    sm: 34,
    md: 34,
    lg: 34,
    xl: 34
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const h5 = {
  fontSize: {
    base: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    sm: 0,
    base: 0,
    lg: 0,
    md: 0,
    xl: 0
  },
  fontFamily: 'body'
};
const h6 = {
  fontSize: {
    base: 20,
    sm: 20,
    md: 20,
    lg: 20,
    xl: 20
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const subtitle1 = {
  fontSize: {
    base: 23,
    sm: 23,
    md: 25,
    lg: 25,
    xl: 25
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 30,
    sm: 30,
    lg: 30,
    md: 30,
    xl: 30
  },
  fontFamily: 'body'
};
const subtitle2 = {
  fontSize: {
    base: 14,
    sm: 14,
    md: 14,
    lg: 14,
    xl: 14
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const body1 = {
  fontSize: {
    base: 16,
    sm: 16,
    md: 16,
    lg: 16,
    xl: 16
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const body2 = {
  fontSize: {
    base: 14,
    sm: 14,
    md: 14,
    lg: 14,
    xl: 14
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const btnLarge = {
  fontSize: {
    base: 15,
    sm: 14,
    md: 14,
    lg: 15,
    xl: 15
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 18,
    sm: 18,
    lg: 18,
    md: 18,
    xl: 18
  },
  textTransform: 'uppercase',
  fontFamily: 'body'
};
const btnMedium = {
  fontSize: {
    base: 14,
    sm: 14,
    md: 14,
    lg: 14,
    xl: 14
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    sm: 26,
    base: 26,
    lg: 26,
    md: 26,
    xl: 26
  },
  letterSpacing: {
    sm: 0.46,
    base: 0.46,
    lg: 0.46,
    md: 0.46,
    xl: 0.46
  },
  textTransform: 'uppercase',
  fontFamily: 'body'
};
const btnSmall = {
  fontSize: {
    base: 13,
    sm: 13,
    md: 13,
    lg: 13,
    xl: 13
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  textTransform: 'uppercase',
  fontFamily: 'body'
};
const overline = {
  fontSize: {
    base: 10,
    sm: 10,
    md: 10,
    lg: 10,
    xl: 10
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const avatarLetter = {
  fontSize: {
    base: 20,
    sm: 20,
    md: 20,
    lg: 20,
    xl: 20
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  fontFamily: 'body'
};
const helperText = {
  fontSize: {
    base: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  fontWeight: {
    base: 'normal',
    sm: 'normal',
    md: 'normal',
    lg: 'normal',
    xl: 'normal'
  },
  lineHeight: {
    base: 15.6,
    sm: 15.6,
    lg: 15.6,
    md: 15.6,
    xl: 15.6
  },
  textTransform: 'uppercase',
  fontFamily: 'body'
};
const tooltip = {
  fontSize: {
    base: 10,
    sm: 10,
    md: 10,
    lg: 10,
    xl: 10
  },
  fontWeight: {
    base: 'medium',
    sm: 'medium',
    md: 'medium',
    lg: 'medium',
    xl: 'medium'
  },
  lineHeight: {
    sm: 0,
    base: 0,
    lg: 0,
    md: 0,
    xl: 0
  },
  fontFamily: 'body'
};
export const typography = {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  subtitle1,
  subtitle2,
  body1,
  body2,
  btnLarge,
  btnMedium,
  btnSmall,
  caption,
  overline,
  avatarLetter,
  inputLabel,
  helperText,
  inputText,
  tooltip,
  trackerItem,
  body20,
  body16,
  subtitle,
  button,
  chips,
  menuItem
};
export { inputLabel, helperText, inputText };
export { btnMedium, btnSmall, btnLarge };
//# sourceMappingURL=index.js.map